import { render, staticRenderFns } from "./ConfigurableDashboard.vue?vue&type=template&id=cddedc04&"
import script from "./ConfigurableDashboard.vue?vue&type=script&lang=js&"
export * from "./ConfigurableDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurableDashboard.vue?vue&type=style&index=0&id=cddedc04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports